import CustomBox from "../../../../../Components/UI/CustomBox/CustomBox/CustomBox";

import "./styles.scss";

const ThreatSummary = ({ threatCounts }) => {
  const {
    high_severity_threats = 0,
    medium_severity_threats = 0,
    low_severity_threats = 0,
    total_threats = 0,
  } = threatCounts || {};

  const isEmpty = total_threats === 0;

  return (
    <CustomBox className="threat-summary">
      <h2 className="threat-summary__title">Threat Summary</h2>

      {isEmpty ? (
        <div className="threat-summary__empty">
          <p>No threats detected</p>
        </div>
      ) : (
        <div className="threat-summary__content">
          {/* <div className="threat-summary__icon">
            <ShieldAlert size={36} color="#ff5252" />
          </div> */}

          <div className="threat-summary__total">
            <span className="threat-summary__total-count">{total_threats}</span>
            <span className="threat-summary__total-label">Total Threats Detected</span>
          </div>

          <div className="threat-summary__levels">
            <div className="threat-summary__levels-item threat-summary__levels-item--high">
              <span className="threat-summary__levels-item-dot" />
              <span>High: {high_severity_threats}</span>
            </div>
            <div className="threat-summary__levels-item threat-summary__levels-item--medium">
              <span className="threat-summary__levels-item-dot" />
              <span>Medium: {medium_severity_threats}</span>
            </div>
            <div className="threat-summary__levels-item threat-summary__levels-item--low">
              <span className="threat-summary__levels-item-dot" />
              <span>Low: {low_severity_threats}</span>
            </div>
          </div>
        </div>
      )}
    </CustomBox>
  );
};

export default ThreatSummary;
